import * as React from "react";
import { Row, Col } from "reactstrap";
import { Query } from "react-apollo";
import * as uuid from "uuid";

// GraphQL
import GetCompanyWorkOrders from "../../GraphQL/Queries/GetCompanyWorkOrders";

// Presentation/UI
import Loader from "../../Components/Loader/DotLoader";
import Table from "../../Components/Table";

// Utils
import { orderDatasetByDateDesc } from "../../Utils/Helpers";

export default class WorkOrders extends React.Component<{ companyId: string }> {
  // Return status
  returnStatus = (word: string): string => {
    switch (word) {
      case "OPEN":
        return "Open";
      case "ON_HOLD":
        return "On Hold";
      case "IN_PROGRESS":
        return "In Progress";
      case "COMPLETE":
        return "Complete";
      default:
        return "None";
    }
  };

  render() {
    const { companyId } = this.props;

    return (
      <Query query={GetCompanyWorkOrders} variables={{ id: companyId }}>
        {({ loading, error, data }) => {
          if (loading) {
            return <Loader />;
          }
          if (error) {
            return <div>There was a problem loading the work orders</div>;
          }

          let workOrders = data.allWorkOrders;
          workOrders = orderDatasetByDateDesc(workOrders);

          return (
            <Row>
              <Col xs={12} md={12} lg={12}>
                <Table
                  data={workOrders}
                  columns={[
                    {
                      Header: "Title",
                      accessor: "title",
                      sortable: false,
                      filterable: false
                    },
                    {
                      Header: "Description",
                      accessor: "description",
                      sortable: false,
                      filterable: false
                    },
                    {
                      Header: "Work Scheduled On",
                      accessor: "dueDate",
                      sortable: false,
                      filterable: false
                    },
                    {
                      id: uuid(),
                      Header: "Status",
                      accessor: (companyWorkOrder: any) => {
                        return this.returnStatus(companyWorkOrder.status);
                      },
                      sortable: false,
                      filterable: false
                    },
                    {
                      id: uuid(),
                      Header: "Site",
                      accessor: (companyWorkOrder: any) => {
                        return !companyWorkOrder.site
                          ? ""
                          : companyWorkOrder.site.name;
                      },
                      sortable: false,
                      filterable: false
                    }
                  ]}
                  defaultPageSize={5}
                  showPaginationTop={false}
                  showPaginationBottom={true}
                />
              </Col>
            </Row>
          );
        }}
      </Query>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Containers/Dashboard/WorkOrders.tsx